import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            韩漫之家
          </span>
          <span className="hidden sm:inline text-xs text-foreground-500 font-label bg-background-100 px-2 py-0.5 rounded-full">
            免费韩国漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/')
                ? 'text-primary-600'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            首页
          </Link>
          <Link
            to="/category/romance"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname.startsWith('/category')
                ? 'text-primary-600'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            分类浏览
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/about')
                ? 'text-primary-600'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-48 px-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
            />
            <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          </div>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 py-2 hover:text-primary-500 transition-colors" onClick={() => setMobileOpen(false)}>
            首页
          </Link>
          <Link to="/category/romance" className="text-sm font-medium text-foreground-700 py-2 hover:text-primary-500 transition-colors" onClick={() => setMobileOpen(false)}>
            分类浏览
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 hover:text-primary-500 transition-colors" onClick={() => setMobileOpen(false)}>
            关于我们
          </Link>
          <div className="relative mt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          </div>
        </div>
      )}
    </nav>
  );
}